import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#65C3FF', cx: '12', cy: '12', r: '12' }),
    React.createElement("path", { key: '1', fill: '#FFFFFF', d: 'M18.1,16l-5.2-5.2c0.5-1.3,0.3-2.8-0.9-4S9.2,5.4,7.8,6.1l2.5,2.5l-1.7,1.7L6.1,7.9c-0.7,1.3-0.4,3,0.7,4.1\n\tc1.1,1.1,2.6,1.4,4,0.9l5.2,5.2c0.3,0.3,0.5,0.3,0.8,0l1.3-1.3C18.3,16.5,18.3,16.1,18.1,16z' }),
], 'TransportConditionGeofenceRepair');
const TransportConditionGeofenceRepairIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionGeofenceRepairIcon);
